import { ComponentProps, FC } from 'react';
import classnames from 'classnames';

const ModalActionBar: FC<Pick<ComponentProps<'div'>, 'children' | 'className'>> = ({ className, children }) => {
  return <div className={classnames('d-flex justify-content-center', className)}>{children}</div>;
};
export { ModalActionBar };
